import * as d3 from "d3";
import { loadedSongs } from "./loadedSongData";
export function makeFrame() {
  const frame = d3.select("#frame").style("background-color", "#f7f4f3ff");
  const formatTimestamp = () => {
    const d = new Date();
    const pad = (v) => String(v).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate()
    )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  };

  frame.selectAll(".border").remove();
  frame.selectAll(".tab").remove();

  const rect = frame.node().getBoundingClientRect();
  const w = rect.width;
  const h = rect.height;
  const borderW = Math.min(w / 20, h / 20, 30);
  const top = frame
    .append("div")
    .attr("class", "border top")
    .style("height", borderW + "px")
    .style("width", "100%")
    .style("position", "absolute")
    .style("padding", `2px ${borderW}px 2px ${borderW}px`)
    .attr("id", "top-border")
    .style("top", "0px")
    .style("left", "0px")
    .style("z-index", 0)
    .style("background-color", "black")
    .style("color", "white")
    .style("display", "flex")
    .style("align-items", "center")
    .style("letter-spacing", "2px")
    .style("font-size", Math.max(6, borderW * 0.3) + "px")
    .style("justify-content", "SPACE-BETWEEN");
  top.append("h4").text("ANIMATED PIANO");
  const songControl = top
    .append("div")
    .attr("class", "song-controls")
    .style("height", `${borderW}px`);
  const options = songControl.append("select").attr("id", "song-select");
  for (const song of loadedSongs) {
    options.append("option").attr("value", song.value).text(song.name);
  }
  songControl
    .append("img")
    .attr("id", "song-play-stop")
    .attr("src", "/play.png");
  songControl.append("div").attr("id", "song-status").text("No song loaded");
  top.append("h4").text(formatTimestamp()).attr("id", "timestamp-label");
  const bottom = frame
    .append("div")
    .attr("class", "border bottom")
    .style("height", borderW + "px")
    .style("width", "100%")
    .style("position", "absolute")
    .style("bottom", "0px")
    .style("left", "0px")
    .style("background-color", "black")
    .style("color", "white")
    .style("z-index", 0)
    .style("display", "flex")
    .style("align-items", "center")
    .style("justify-content", "SPACE-BETWEEN")
    .style("padding", `2px ${borderW}px 5px ${borderW}px`)
    .style("letter-spacing", "2px")
    .style("font-size", Math.max(6, borderW * 0.3) + "px");

  bottom.append("h4").text("NOTES").attr("id", "notes-bottom");
  bottom.append("h4").text("OCTAVE").attr("id", "octave-bottom");
  bottom.append("h4").text("BY KATHERINE CHUI");

  setInterval(() => {
    const frame = d3.select("#frame");
    const labelTop = frame.select("#timestamp-label");
    if (!labelTop.empty()) labelTop.text(formatTimestamp());
    const labelBottom = frame.select("#timestamp-label-bottom");
    if (!labelBottom.empty()) labelBottom.text(formatTimestamp());
  }, 1000);
  const left = frame
    .append("div")
    .attr("class", "border left")
    .style("width", borderW + "px")
    .style("height", "100%")
    .style("position", "absolute")
    .style("top", "0px")
    .style("z-index", 0)
    .style("left", "0px")
    .style("background-color", "black")
    .style("display", "flex")
    .style("flex-direction", "column")
    .style("justify-content", "space-evenly")
    .style("align-items", "center")
    .style("padding", `${borderW * 0.3}px 0`);
  left
    .append("h4")
    .text("lx:")
    .attr("id", "look-x")
    .style("transform", "rotate(90deg)");
  left
    .append("h4")
    .text("ly:")
    .attr("id", "look-y")
    .style("transform", "rotate(90deg)");
  left
    .append("h4")
    .text("lz:")
    .attr("id", "look-z")
    .style("transform", "rotate(90deg)");
  const right = frame
    .append("div")
    .attr("class", "border right")
    .style("width", borderW + "px")
    .style("height", "100vh")
    .style("position", "absolute")
    .style("top", "0px")
    .style("right", "0px")
    .style("display", "flex")
    .style("flex-direction", "column")
    .style("justify-content", "space-evenly")
    .style("align-items", "center")
    .style("padding", `${borderW * 0.3}px `)
    .style("z-index", 0)
    .style("background-color", "black");

  right
    .append("h4")
    .text("x:")
    .attr("id", "pos-x")
    .style("transform", "rotate(-90deg)");
  right
    .append("h4")
    .text("y:")
    .attr("id", "pos-y")
    .style("transform", "rotate(-90deg)");

  right
    .append("h4")
    .text("z:")
    .attr("id", "pos-z")
    .style("transform", "rotate(-90deg)");

  const tabSize = borderW / 2;

  const tabs = [
    { x: (borderW * 5) / 4, y: (borderW * 5) / 4 },
    { x: w - (borderW * 5) / 4, y: (borderW * 5) / 4 },
    { x: (borderW * 5) / 4, y: h - (borderW * 5) / 4 },
    { x: w - (borderW * 5) / 4, y: h - (borderW * 5) / 4 },

    { x: w / 3, y: (borderW * 5) / 4 },
    { x: (w / 3) * 2, y: (borderW * 5) / 4 },
    { x: w / 3, y: h - (borderW * 5) / 4 },
    { x: (w / 3) * 2, y: h - (borderW * 5) / 4 },
    { x: (borderW * 5) / 4, y: h / 2 },
    { x: w - (borderW * 5) / 4, y: h / 2 },
  ];
  frame
    .selectAll(".tab")
    .data(tabs)
    .enter()
    .append("div")
    .style("z-index", "-1")
    .attr("class", "tab")
    .style("width", tabSize + "px")
    .style("height", tabSize + "px")
    .style("position", "absolute")
    .style("display", "flex")
    .style("align-items", "center")
    .style("justify-content", "center")
    .style("background-color", "black")
    .style("top", (d) => d.y + "px")
    .style("left", (d) => d.x + "px")
    .style("transform", "translate(-50%, -50%)")
    .append("div")
    .attr("class", "tab-inner")
    .style("width", "30%")

    .style("height", "30%")
    .style("border", ".5px solid white")
    .style("border-radius", tabSize + "px");
}

export function setTabsHidden(hidden) {
  const frame = d3.select("#frame");
  const rect = frame.node()?.getBoundingClientRect();
  const w = rect?.width || 0;
  const h = rect?.height || 0;

  frame
    .selectAll(".tab")
    .style("transition", "top 0.65s ease, left 0.65s ease")
    .style("top", (d) => {
      if (!hidden) return `${d.y}px`;
      return d.y < h / 2 ? "0px" : `${h}px`;
    })
    .style("left", (d) => {
      if (!hidden) return `${d.x}px`;
      return d.x < w / 2 ? "0px" : `${w}px`;
    })
    .style("transform", "translate(-50%, -50%)");
}
